import { Component } from '@angular/core';

@Component({
  selector: 'app-bobby-calves-preseason-landing',
  templateUrl: './bobby-calves-preseason-landing.component.html',
  styleUrls: ['./bobby-calves-preseason-landing.component.scss'],
})
export class BobbyCalvesPreseasonLandingComponent {}
